import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Col, Row, Spinner } from "react-bootstrap";
import CountUp from "react-countup";
import { useSelector, useDispatch } from "react-redux";
import { fetchLandingPageCount } from "../../../redux/actions/landingPageCountAction";

function YearlyCounts() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const dispatch = useDispatch();
  let count = useSelector((state) => state.landingPageCount);

  const loading = () => {
    return (
      <div>
        <Spinner size="sm" animation="grow" variant="secondary" />
        <Spinner size="sm" animation="grow" variant="secondary" />
        <Spinner size="sm" animation="grow" variant="secondary" />
      </div>
    );
  };

  useEffect(() => {
    if (count.isFetching) {
      fetchLandingPageCount(currentYear, dispatch);
    }
  }, []);

  return (
    <div
      className="section section-standout"
      style={{ paddingTop: "10px", paddingBottom: "10px" }}
    >
      <Container>
        <Row>
          <Col md="4">
            <div className="stat-counter text-accent-p1 epa-id-counter">
              <div>
                {count.isFetching ? (
                  loading()
                ) : (
                    <CountUp duration={1} separator="," end={count.epaIdCount} />
                  )}
              </div>
              <div className="text-center" style={{ fontSize: "1rem" }}>
                ID Numbers Issued in {currentYear}
              </div>
            </div>
          </Col>
          <Col md="4">
            <div className="stat-counter text-accent-p1 manifest-counter">
              <div>
                {count.isFetching ? (
                  loading()
                ) : (
                    <CountUp
                      duration={1}
                      separator=","
                      end={count.manifestCount}
                    />
                  )}
              </div>
              <div className="text-center" style={{ fontSize: "1rem" }}>
                Manifests Reported in {currentYear}
              </div>
            </div>
          </Col>
          <Col md="4">
            <div className="stat-counter text-accent-p1 tonnage-counter">
              <div>
                {count.isFetching ? (
                  loading()
                ) : (
                    <CountUp
                      duration={1}
                      separator=","
                      end={count.tonnageCount}
                    />
                  )}
              </div>
              <div className="text-center" style={{ fontSize: "1rem" }}>
                Tons of Waste Handled in {currentYear}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <div style={{ textAlign: "Center", fontSize: "small" }}>
              The word “Handler” on this site refers to any hazardous waste generator, transporter, universal waste handler, or permitted treatment, storage, transfer, or disposal facility that handles hazardous waste.
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default YearlyCounts;
